/**
 * Google Analytics pageviews.
 *
 * The tracker itself is created by the snippet at the end of public/index.html,
 * copied from the Play site. That snippet deliberately leaves out the initial
 * `ga('send', 'pageview')`: this app navigates on the client, so pageviews are
 * sent from here on every route change instead, which is what makes the counts
 * line up with the server-rendered site.
 */

type GoogleAnalytics = (...args: unknown[]) => void;

declare global {
  interface Window {
    ga?: GoogleAnalytics;
  }
}

/**
 * Report a pageview for `path`, which should include the query string when there
 * is one -- the old site tracked those as distinct pages.
 *
 * The snippet defines `window.ga` as a queue before analytics.js finishes
 * loading, so this is safe to call immediately. It is a no-op when the snippet
 * did not run at all, such as under a blocker or in tests.
 */
export const trackPageview = (path: string) => {
  if (!window.ga) {
    return;
  }

  window.ga('set', 'page', path);
  window.ga('send', 'pageview');
};
